var _path, _path2, _ellipse, _ellipse2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMedicine(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 30,
    viewBox: "0 0 27 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2758 17.9332H0.979492V7.66657H1.01271C1.38696 3.55514 4.87724 0.333252 9.12764 0.333252C13.378 0.333252 16.8683 3.55514 17.2426 7.66657H17.2758V17.9332Z",
    fill: "#D2D2D8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.979493 15L9.09887 15C9.10846 15 9.11805 15 9.12764 15C9.13723 15 9.14682 15 9.15641 15L17.2758 15L17.2758 22.3334H17.2426C16.8683 26.4448 13.378 29.6667 9.12764 29.6667C4.87725 29.6667 1.38697 26.4448 1.01271 22.3334H0.979492L0.979493 15Z",
    fill: "#91919C"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 19.4974,
    cy: 20.0955,
    rx: 6.66667,
    ry: 6.66667,
    transform: "rotate(-180 19.4974 20.0955)",
    fill: "#91919C"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 18.2594,
    cy: 20.0955,
    rx: 6.66667,
    ry: 6.66667,
    transform: "rotate(-90 18.2594 20.0955)",
    fill: "url(#paint0_linear_31182_179)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_31182_179",
    x1: 18.6549,
    y1: 19.7895,
    x2: 25.2487,
    y2: 29.5846,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D2D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#C4C4C4"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedicine);
export default __webpack_public_path__ + "static/media/Medicine.034e6a5de00964daf88cf15ebbf7f50b.svg";
export { ForwardRef as ReactComponent };